<template>
	<el-card class="guest-container">
	    <template #header>
	      <div class="header">
			  <el-button type="primary" size="small" icon="el-icon-plus" @click="edit('')">新增</el-button>
			  <!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addAdmin">新增</el-button> -->
	        <!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="handleSolve">解除禁用</el-button>
	        <el-button type="danger" size="small" icon="el-icon-delete" @click="handleForbid">禁用账户</el-button> -->
	      </div>
	    </template>
	    <el-table
	      v-loading="loading"
	      ref="multipleTable"
	      :data="list"
	      tooltip-effect="dark"
	      style="width: 100%"
	      @selection-change="handleSelectionChange">
	  
	      <el-table-column
	        prop="nick_name"
	        label="昵称"
	      >
	      </el-table-column>
	      <el-table-column
	        prop="username"
	        label="登录名"
	      >
	      </el-table-column>
	      <el-table-column
	        label="身份状态"
	      >
	        <template #default="scope">
	          <!-- <span :style="scope.row.status == 1 ? 'color: green;' : 'color: red;'">
	            {{ scope.row.status == 1 ? '正常' : '禁用' }}
	          </span> -->
			  <el-switch
			                  v-model="scope.row.status"
							  :disabled="scope.row.id ===1"
			                  active-color="#409EFF"
			                  inactive-color="#F56C6C"
							  :active-value="1"
							  :inactive-value="2"
			                  @change="changeEnabled(scope.row, scope.row.status,$index)"
			                />
	        </template>
	      </el-table-column>
	     <!-- <el-table-column
	        label="是否注销"
	      >
	        <template #default="scope">
	          <span :style="scope.row.lockedFlag == 0 ? 'color: green;' : 'color: red;'">
	            {{ scope.row.isDeleted == 0 ? '正常' : '注销' }}
	          </span>
	        </template>
	      </el-table-column> -->
	      <el-table-column
	        prop="created_at"
	        label="注册时间"
	      >
	      </el-table-column>
		 <!-- <el-table-column
		    prop="last_login_time"
		    label="上次登录时间"
		  >
		  </el-table-column> -->
	      <el-table-column
	        label="操作"
	        width="auto"
	      >
	        <template #default="scope">
			  <el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
			  <el-button type="warning" size="mini" @click="del(scope.row)">删除</el-button>
	        </template>
	      </el-table-column>
	    </el-table>
	    <!--总数超过一页，再展示分页器-->
	    <!-- <el-pagination
	      background
	      layout="prev, pager, next"
	      :total="total"
	      :page-size="pageSize"
	      :current-page="currentPage"
	      @current-change="changePage"
	    /> -->
	  </el-card>
	  <el-dialog title="管理员管理" v-model="dialogFormVisible">
	    <el-form :model="form" ref='form' :rules="rules">
	      <el-form-item prop="username" label="账户名" :label-width="formLabelWidth">
	        <el-input v-model="form.username"  autocomplete="off"></el-input>
	      </el-form-item>
		  <el-form-item prop="username" label="密码" :label-width="formLabelWidth">
		    <el-input v-model="form.password" autocomplete="off" show-password></el-input>
		  </el-form-item>
		  <el-form-item prop="username" label="昵称" :label-width="formLabelWidth">
		    <el-input v-model="form.nick_name" autocomplete="off"></el-input>
		  </el-form-item>
		  <el-form-item prop="username" label="邮箱" :label-width="formLabelWidth">
		    <el-input v-model="form.email" autocomplete="off"></el-input>
		  </el-form-item>
		  
	      <el-form-item  label="角色" :label-width="formLabelWidth" prop="role_id">
	        <el-select v-model="form.role_id" placeholder="请选择角色">
	          <el-option v-for="item in roleData" :key="item.role_name" :label="item.role_name" :value="item.id"></el-option>
	        </el-select>
	      </el-form-item>
	    </el-form>
	    <template #footer>
	      <span class="dialog-footer">
	        <el-button @click="dialogFormVisible = false">取 消</el-button>
	        <el-button type="primary"  @click="submit()">确 定</el-button>
	      </span>
	    </template>
	  </el-dialog>
</template>

<script>
	export default{
		name:'AdminList',
		data(){
			return{
				list:[],
				loading: false,
				multipleSelection: [],
				dialogFormVisible: false,
				formLabelWidth: '120px',
				ishowAddButton:true,
				ishowDelButton:true,
				addDisabled:false,
				delDisabled:false,
				btnDisabled:true,
				roleData:[],
				form:{
					username:'',
					password:'',
					nick_name:'',
					email:'',
					role_id:''
				},
				rules:{
					username:[{
						required: true,
						message: '用户名不能为空',
						trigger: 'blur'
					}],
					password:[{
						required: true,
						message: '密码不能为空',
						trigger: 'blur'
					}],
					re_password:[{
						required: true,
						message: '确认密码不能为空',
						trigger: 'blur'
					}],
					nick_name:[{
						required: true,
						message: '昵称不能为空',
						trigger: 'blur'
					}],
					email:[{
						required: true,
						message: '邮箱不能为空',
						trigger: 'blur'
					}],
					role_id:[{
						required: true,
						message: '角色必选',
						trigger: 'change'
					}],
				}
			}
		},
		methods:{
			getAdminList(){
				
				this.httpPost({
					url:'/admin/admin/admin_list',
					data:{
						routePath: this.$route.path
					}
				}).then((res)=>{
					this.list = res.data;
					this.getRole();

				})
				
			},
			getRole(){
				this.loading = true;
				this.httpPost({
					'url':'/admin/role/role_list'
				}).then((re) => {
					  	let data = re.data
					  	// console.log(data)
					  	let temp = this.cloneObj(data);
					  	this.roleData = temp;
					  	this.loading = false;
					  
					  }).catch((err) => {
					  	this.loading = false;
					  })
			},
			edit(val){
				this.form={
					id:val.id,
					username:val.username,
					password:val.password,
					nick_name:val.nick_name,
					email:val.email,
					role_id:val.role_id,
				},
				this.dialogFormVisible=true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			del(val){
				let id = val.id;
				if(id ==1) {
					this.$message.error('不能删除最高权限用户!');
					return false;
				}
				
				this.msgBoxAjax(
				  '提示',
				  '确定删除该用户吗？',
				  "/admin/admin/admin_del",
				  {id:id}).then((data) => {
				  // console.log(data);
							
				  if (data.code == 1) {
					  this.dialogFormVisible=false;
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
				      this.getAdminList();
				    });
				  }else{
							
				    this.messageCommon('错误',data.msg,'error');
				  }
							
							
				});
			},
			changeEnabled(data, val){
				let select_id = data.id;
				let change_status = val;
				if(select_id){
					this.loading=true;
					this.httpPost({
						url:'/admin/admin/change_status',
						data:{id:select_id,status:change_status}
					}).then((res)=>{
						if(res.code ==1){
							this.$message.success(res.msg);
							this.loading =false;
						}
					})
				}
			},
			 handleSelectionChange(val) {
			    this.multipleSelection = val;
			},
			handleSolve(){
				if(!this.multipleSelection.length){
					this.$message.error('请选择项');
					return;
				}else{
					let ids = this.multipleSelection.map(item=>item.id);
					this.httpPost({
						url:'/admin/admin/handleSolve',
						data:ids,
					}).then((res)=>{
						// console.log(res)
						this.$message.success(res.msg);
						this.getAdminList();
					});
					
				}
			},
			handleForbid(){
				if(!this.multipleSelection.length){
					this.$message.error('请选择项');
					return;
				}else{
					let ids = this.multipleSelection.map(item=>item.id);
					// console.log(ids);return;
					this.httpPost({
						url:'/admin/admin/handleForbid',
						data:ids,
					}).then((res)=>{
						// console.log(res)
						this.$message.success(res.msg);
						this.getAdminList();
					});
				}
			},
			submit(){
				this.$refs['form'].validate((valid)=>{
					if(valid){
						this.updateAdmin();
					}else{
						console.log('error submit!')
						return false;
					}
				})
			},
			updateAdmin() {
			
			
			        let temp = this.cloneObj(this.form);
			
			        delete temp.re_password;
			
			        let id = temp.id;
			
			        console.log(id);
			
			        if (!id) id = '';
			
			
			        this.msgBoxAjax(
			          '提示',
			          '确定修改吗？',
			          "/admin/admin/admin_update?id=" + id,
			          temp).then((data) => {
			          // console.log(data);
			
			          if (data.code == 1) {
						  this.dialogFormVisible=false;
			            this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
			              this.getAdminList();
			            });
			          }else{
			
			            this.messageCommon('错误',data.msg,'error');
			          }
			
			
			        });
			
			      },
		},
		created(){
			this.getAdminList();
			// if (this.form.id) this.getDetail(); this.rules.password = [];this.rules.re_password = [];
		}
	}
</script>

<style>
	.guest-container {
	    min-height: 100%;
	}
	.el-card.is-always-shadow {
	    min-height: 100%!important;
	}
</style>
